import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4543b7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['card-footer'])
}
const _hoisted_4 = { class: "card-header-title" }
const _hoisted_5 = { class: "ticket-price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-footer-pricefrom" }, "PRIS FRÅN:", -1))
const _hoisted_7 = { class: "card-footer-price" }
const _hoisted_8 = {
  key: 0,
  class: "promo-msg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promo-text" }, "15% rabatt", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['card-footer'])
}
const _hoisted_12 = { class: "card-header-title" }
const _hoisted_13 = { class: "buy-ticket-wrapper" }
const _hoisted_14 = { class: "price-and-button-wrapper" }

import { reactive, PropType } from "vue";
import CustomCard from "../generics/CustomCard.vue";
import CustomSelect from "../generics/CustomSelect.vue";
import CustomButton from "../generics/CustomButton.vue";
import { useBookingStore } from "@/store/bookingStore";
import QuestionMark from "@/assets/SVG/questionMark.vue";
import CustomModal from "../generics/CustomModal.vue";
import InfoIcon from "@/assets/SVG/InfoIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketPresentationCard',
  props: {
	ticket: {
		type: Object as PropType<{
			id: string;
			title: string;
			price_object: {
				age: string;
				comfort: string;
				price: number;
				sku: string;
				VAT: number;
			}[];
			promotion: boolean;
		}>,
		required: true,
	},
	isOpen: {
		type: Boolean,
		default: false,
	},
	backgroundImgClass: {
		type: String,
		default: "background-backpack",
	},
},
  emits: ["clicked"],
  setup(__props, { emit: emits }) {

const props = __props;

const bookingStore = useBookingStore();





const state = reactive({
	current_exact_price: 0,
	current_ticket_age: null,
	current_ticket_comfort: null,
	info_open: false,
});

const age_obj = [
	{ value: "CHD", name: "Barn 0-11 år" },
	{ value: "YTH", name: "Ungdom 12-27 år" },
	{ value: "ADT", name: "Vuxen 28-59 år" },
	{ value: "SEN", name: "Senior 65+ år" },
];

const comfort_obj = [
	{ value: "first", name: "Första klass" },
	{ value: "second", name: "Andra klass" },
];

const daysInMonthText = (travelDays: number, traveltime: string) =>
	`Denna biljett ger dig tillgång till ${travelDays} resdagar att använda
      under ${traveltime}s tid. Under en resdag kan du åka med hur många tåg du vill
      och resedagarna går att aktivera när du vill under ${traveltime} från ditt
      första resedatum. \n Perfekt när du vill besöka ${
				travelDays - 2
			} - ${travelDays} destinationer.`;

const daysConsecutiveText = (travelDays: string) =>
	`Denna biljett ger dig tillgång till ${travelDays} att använda i följd från första resedatum. Du kan åka med hur många tåg du vill under dessa dagar. \n Perfekt när du vill resa mycket under en kortare tid eller bara ha full frihet i ditt resande.`;

const activationText = () =>
	"Passet aktiveras i RailPlanner appen. Kunddetaljer anges i nästa steg. Ha en trevlig resa!";

const descriptions = {
	"4 dagar på 1 månad": daysInMonthText(4, "1 månad") + activationText(),
	"5 dagar på 1 månad": daysInMonthText(5, "1 månad") + activationText(),
	"7 dagar på 1 månad": daysInMonthText(7, "1 månad") + activationText(),
	"10 dagar på 2 månader": daysInMonthText(10, "2 månader") + activationText(),
	"15 dagar på 2 månader": daysInMonthText(15, "2 månader") + activationText(),
	"15 dagar i följd": daysConsecutiveText("15 resdagar") + activationText(),
	"22 dagar i följd": daysConsecutiveText("22 resdagar") + activationText(),
	"1 månad i följd":
		daysConsecutiveText("1 månads resdagar") + activationText(),
	"2 månad i följd":
		daysConsecutiveText("2 månader resdagar") + activationText(),
	"3 månad i följd":
		daysConsecutiveText("3 månader resdagar") + activationText(),
};

function handleClick() {
	emits("clicked", props.ticket.id);
}

function get_lowest_price() {
	const with_no_zeros = props.ticket.price_object.filter(
		(obj) => obj.price != 0
	);
	const lowest = with_no_zeros.reduce(function (prev, curr) {
		return prev.price < curr.price ? prev : curr;
	});
	return lowest.price;
}

function handleSelectedAge(age: any) {
	state.current_ticket_age = age.value;
	recalculate_price();
}

function handleSelectedComfort(comfort: any) {
	state.current_ticket_comfort = comfort.value;
	recalculate_price();
}

function recalculate_price() {
	if (!state.current_ticket_age && !state.current_ticket_comfort) {
		return;
	} else {
		const current_price_obj = props.ticket.price_object.find(
			(el) =>
				el.age == state.current_ticket_age &&
				el.comfort == state.current_ticket_comfort
		);

		if (current_price_obj) {
			state.current_exact_price = current_price_obj.price;
		}
	}
}

function addTicketToCart() {
	if (
		state.current_ticket_age == null &&
		state.current_ticket_comfort == null
	) {
		return;
	}
	emits("clicked", "");

	let price_obj_for_ticket = props.ticket.price_object.find(
		(el) =>
			el.age == state.current_ticket_age &&
			el.comfort == state.current_ticket_comfort
	);

	bookingStore.add_to_shopping_cart({
		id: props.ticket.id,
		title: props.ticket.title,
		type: "ticket",
		sku: String(price_obj_for_ticket?.sku),
		VAT: price_obj_for_ticket?.VAT,
		firstName: "",
		lastName: "",
		age: state.current_ticket_age ? state.current_ticket_age : "",
		comfort: state.current_ticket_comfort ? state.current_ticket_comfort : "",
		country: "",
		dateOfBirth: "",
		price: Number(state.current_exact_price),
		refundable: true,
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CustomCard, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CustomButton, {
              "icon-button": true,
              variant: "secondary",
              class: "about-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (state.info_open = true))
            }, {
              default: _withCtx(() => [
                _createVNode(InfoIcon)
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              onClick: handleClick,
              class: _normalizeClass([
						'card-header',
						__props.isOpen ? 'card-header-open' : '',
						__props.backgroundImgClass,
					])
            }, null, 2),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.ticket?.title), 1),
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(get_lowest_price()) + " KR ", 1),
                          (__props.ticket.promotion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (!__props.isOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(__props.ticket?.title), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(CustomSelect, {
                          label: "Åldersgrupp",
                          initialySelected: 
									state.current_ticket_age == null
										? ''
										: age_obj.find((el) => el.value == state.current_ticket_age)
												?.name
								,
                          options: age_obj,
                          onSelected: handleSelectedAge
                        }, null, 8, ["initialySelected"]),
                        _createVNode(CustomSelect, {
                          label: "Komfort",
                          initialySelected: 
									state.current_ticket_comfort == null
										? ''
										: comfort_obj.find(
												(el) => el.value == state.current_ticket_comfort
										  )?.name
								,
                          options: comfort_obj,
                          onSelected: handleSelectedComfort
                        }, null, 8, ["initialySelected"]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, _toDisplayString(state.current_exact_price) + " kr", 1),
                          _createVNode(CustomButton, {
                            onOnClick: addTicketToCart,
                            disabled: 
										state.current_ticket_age == null ||
										state.current_ticket_comfort == null
									
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Lägg i korg ")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(CustomModal, {
      show: state.info_open,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (state.info_open = false))
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.ticket.title), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(descriptions[__props.ticket?.title as String]), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})